export default [
  {
    title: 'breadcrumb.player',
    route: 'list-player',
    icon: 'UserIcon',
    resource: 'player',
    action: 'read'
  }
];